// extracted by mini-css-extract-plugin
module.exports = {"appCard":"_1s0LaHo1oxFkCkJcJP_Nqt","avatar":"_1E2FG4ki6-QM_XZzN7TErH","subButtons":"_1UIK8TLUI59LL7TnJOW0Id","description":"_2D4D1yZuYENhgCC0mGDqEN"};